"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const LetterIcon_module_css_1 = __importDefault(require("./styles/LetterIcon.module.css"));
const LetterIcon = ({ name, size = "sm", form = "circle", additionalClassName }) => {
    const getLetters = () => {
        if (!name) {
            return "?";
        }
        const upperName = name.toUpperCase();
        const split = upperName.split(" ");
        if (split.length == 1) {
            return split[0].charAt(0);
        }
        return split[0].charAt(0) + split[1].charAt(0);
    };
    const getClassContainerClassNames = () => {
        let formClassName = "";
        let sizeClassName = "";
        switch (form) {
            case "circle":
                formClassName = LetterIcon_module_css_1.default.circle;
                break;
            case "square":
                formClassName = LetterIcon_module_css_1.default.square;
        }
        switch (size) {
            case "lg":
                sizeClassName = LetterIcon_module_css_1.default.lg;
                break;
            case "sm":
                sizeClassName = LetterIcon_module_css_1.default.sm;
                break;
        }
        return `${LetterIcon_module_css_1.default.container} ${formClassName} ${sizeClassName} ${additionalClassName ? additionalClassName : ""}`;
    };
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: getClassContainerClassNames() }, { children: getLetters() }));
};
exports.default = LetterIcon;
